export const AccessRole = {
  FREE_BUSY_READER: "freeBusyReader",
  OWNER: "owner",
  WRITER: "writer",
  READER: "reader",
} as const;
export type AccessRoleType = (typeof AccessRole)[keyof typeof AccessRole];

export const UserCalendarAccessType = {
  EDITABLE: "editable",
  READONLY: "readonly",
} as const;

export type UserCalendarAccessType =
  (typeof UserCalendarAccessType)[keyof typeof UserCalendarAccessType];
